'use client'
import * as React from 'react'

import { useSelectedTeamAndRepo } from '~/hooks-data/use-selected-team-and-repo'
import { isUserRepo } from '@basehub/data/replicache/mutators/_public-types'
import { APIExplorer } from './explorer'
import { useSelectedBranchOrCommitQuery } from '~/lib/commits/use-selected-branch-or-commit'

export const APIExplorerTab = () => {
  const { data, isLoading } = useSelectedTeamAndRepo()
  const { data: selectedBranchOrCommit } = useSelectedBranchOrCommitQuery()

  let readToken = ''
  let adminToken = ''
  if (isUserRepo(data?.repo)) {
    data?.repo?.tokens.forEach((t) => {
      if (t.scope === 'read') {
        readToken = t.token
      } else if (t.scope === 'write') {
        adminToken = t.token
      }
    })
  }

  return (
    <>
      <React.Suspense fallback={<p>Loading...</p>}>
        {!isLoading && (
          <>
            {readToken && adminToken ? (
              <APIExplorer
                variant="authenticated"
                readToken={readToken}
                adminToken={adminToken}
                selectedBranchOrCommit={selectedBranchOrCommit}
                repoId={data?.repo?.id}
              />
            ) : (
              <APIExplorer variant="unauthenticated" repoId={data?.repo?.id} />
            )}
          </>
        )}
      </React.Suspense>
    </>
  )
}
